// Eigene, schlichte Strich-Icons der Voice-UI (24er Raster, currentColor).
import type { ReactNode } from 'react';

function Svg({ children, title }: { children: ReactNode; title?: string }) {
  return (
    <svg
      className="lf-voice-icon"
      viewBox="0 0 24 24"
      width="20"
      height="20"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden={title ? undefined : true}
      role={title ? 'img' : undefined}
    >
      {title ? <title>{title}</title> : null}
      {children}
    </svg>
  );
}

const Slash = () => <path d="M4 4l16 16" />;

export function MicIcon({ off }: { off?: boolean }) {
  return (
    <Svg>
      <rect x="9" y="3" width="6" height="11" rx="3" />
      <path d="M5.5 11a6.5 6.5 0 0 0 13 0M12 17.5V21M8.5 21h7" />
      {off ? <Slash /> : null}
    </Svg>
  );
}

export function HeadphonesIcon({ off }: { off?: boolean }) {
  return (
    <Svg>
      <path d="M4 15v-3a8 8 0 0 1 16 0v3" />
      <rect x="3.5" y="14" width="4" height="6" rx="1.6" />
      <rect x="16.5" y="14" width="4" height="6" rx="1.6" />
      {off ? <Slash /> : null}
    </Svg>
  );
}

export function CameraIcon({ off }: { off?: boolean }) {
  return (
    <Svg>
      <rect x="3" y="6.5" width="12.5" height="11" rx="2.4" />
      <path d="M15.5 10.5l5-3v9l-5-3" />
      {off ? <Slash /> : null}
    </Svg>
  );
}

export function ScreenIcon({ active }: { active?: boolean }) {
  return (
    <Svg>
      <rect x="3" y="4.5" width="18" height="12" rx="2" />
      <path d="M8.5 20h7M12 16.5V20" />
      {active ? <path d="M12 13V8M9.5 10.5L12 8l2.5 2.5" /> : null}
    </Svg>
  );
}

export function LeaveIcon() {
  return (
    <Svg>
      <path d="M4.5 14.5c4.5-4 10.5-4 15 0l-1.8 2.3-3.2-1.4v-2.3a9 9 0 0 0-5 0v2.3l-3.2 1.4z" />
    </Svg>
  );
}

export function GearIcon() {
  return (
    <Svg>
      <circle cx="12" cy="12" r="3" />
      <path d="M12 2.8v2.4M12 18.8v2.4M2.8 12h2.4M18.8 12h2.4M5.5 5.5l1.7 1.7M16.8 16.8l1.7 1.7M5.5 18.5l1.7-1.7M16.8 7.2l1.7-1.7" />
    </Svg>
  );
}

export function ExpandIcon() {
  return (
    <Svg>
      <path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5" />
    </Svg>
  );
}

export function SpeakerIcon() {
  return (
    <Svg>
      <path d="M4 9.5h3.5L12 5.5v13l-4.5-4H4z" />
      <path d="M15.5 9a4 4 0 0 1 0 6M18 6.5a7.5 7.5 0 0 1 0 11" />
    </Svg>
  );
}
